export const isFormValid = (state) => {
  const { driver, contractor } = state;

  const mandatoryDriverFields = [
    "primerApellido",
    "segundoApellido",
    "nombres",
    "fechaNacimiento",
    "genero"
  ];

  const mandatoryContractorFields = [
    "primerApellido",
    "segundoApellido",
    "nombres",
    "fechaNacimiento",
    "genero",
    "rfc",
    "correoElectronico",
    "telefonoMovil",
    "codigoPostal",
    "colonia",
    "alcaldiaMunicipio",
    "estadoRepublica",
    "calle",
    "numeroExterior",
    "regimenFiscal",
    "fiscalCodigoPostal",
    "fiscalColonia",
    "fiscalAlcaldiaMunicipio",
    "fiscalEstadoRepublica",
    "fiscalCalle",
    "fiscalNumeroExterior"
  ];

  const driverValid = mandatoryDriverFields.every((field) => {
    const valid = driver.validValues[field] === true;
    return valid;
  });

  const contractorValid = mandatoryContractorFields.every((field) => {
    const valid = contractor.validValues[field] === true;
    return valid;
  });

  const result = driverValid && contractorValid;
  
  return result;
};
